<template>
    <div>
        <div :style="inner" class="scrollArea">
            <el-scrollbar style="height: 100%" ref="elScrollbar">
                <div class="titles" style="
                        text-align: center;
                        height: 60px;
                        line-height: 60px;
                        font-size: 24px;
                        font-weight: bold;
                    ">
                    人才培养方案
                </div>
                <el-row>
                    <teaching-form ref="teachingForm" @loadParams="loadParams" :isEdit="isEdit" :state="state"></teaching-form>
                </el-row>

                <el-row>
                    <occupation-scope ref="occupation" :state="state" @changeEditRow="changeEditRow"></occupation-scope>
                </el-row>

                <el-row>
                    <talent ref="talent" :state="state" @changeEditRow="changeEditRow"></talent>
                </el-row>

                <el-row>
                    <teaching-weeks @transweeks="transweeks" @changeArrange="changeArrange" ref="teachingWeeks" :state="state"></teaching-weeks>
                </el-row>
                <el-row>
                    <CAP ref="CAP" :publicCourse="publicCourse" :majorCoreCourse="majorCoreCourse" :majorSkillCourse="majorSkillCourse"
                        :electiveCourse="electiveCourse" :comprehensiveCourse="comprehensiveCourse" :other="other"
                        :state="state" @changeEditRow="changeEditRow" @openWindow="openWindow"></CAP>
                </el-row>

                <el-row>
                    <teaching-arrangement ref="arrangement" :state="state" @changeEditRow="changeEditRow"></teaching-arrangement>
                </el-row>

                <comment :state="state" :filelist="filelist" :etype="etype" ref="comment"></comment>
            </el-scrollbar>
        </div>

        <el-row>
            <el-col :span="8">
                <p></p>
            </el-col>
            <el-col :span="8">
                <p></p>
            </el-col>
            <el-col :span="8">
                <div class="myfooter">
                    <el-button type="primary" :loading="formSubmiting" @click="saveScheme('save')" :disabled="state">保 存</el-button>
                    <el-button type="warning" :loading="formSubmiting" @click="submitWapper()" :disabled="state">提 交</el-button>
                    <el-button type="danger" :loading="formSubmiting" @click="saveScheme('audit')" v-show="false">审 核</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import { confirmMsg } from "utils/message";
    import { apiUrl } from "static/config";
    import occupationScope from "./occupationScope";
    import talent from "./talent";
    import CAP from "./CourseAndProgress";
    import teachingArrangement from "./teachingArrangement";
    import teachingWeeks from "./teachingWeeks";
    import teachingForm from "./teachingForm";
    import comment from "./comment.vue";
    
    export default {
        components: {
            talent,
            occupationScope,
            CAP,
            teachingArrangement,
            teachingWeeks,
            teachingForm,
            comment,
        },
        created() {
            let schemeId = this.$route.query.schemeId;

            this.schemeId = schemeId;
            this.inner.height = window.innerHeight * 0.93 + "px";
            this.init(schemeId);
        },
        mounted() {
            this.$nextTick(() => {
                // 改变合计行样式
                $(".el-table__footer-wrapper").css("font-weight", "bold");
                $(".el-table__footer-wrapper tr").css("font-weight", "bold");
            });
        },
        data() {
            return {
                schemeId: null, //培养方案Id
                etype: "-1", //状态标识
                isEdit: null, //是否是编辑状态
                state: false, // 提交状态下disable
                publicCourse: [],
                majorCoreCourse: [],
                majorSkillCourse: [],
                electiveCourse: [],
                comprehensiveCourse: [],
                other: [],
                filelist: [],
                inner: {
                    height: "790px",
                },
                formSubmiting: false,
            };
        },
        methods: {
            init(schemeId) {
                //等价于 原showDialog
                if (schemeId == "null") {
                    //create
                    this.isEdit = false;
                    this.etype = "-1";
                    this.$nextTick(() => {
                        this.$refs.teachingForm.createdForm.jpShzt = "-1";
                        this.$refs.teachingForm.createdForm.userName = localStorage.getItem(
                            "name"
                        );
                        this.$refs.teachingForm.createdForm.jpCjr = localStorage.getItem(
                            "user"
                        );
                    });
                } else {
                    //edit
                    this.unlock();
                    this.isEdit = true;
                    let param = {
                        schemeId: schemeId,
                    };
                    let id = schemeId;
                    let mode = id[id.length - 1];
                    this.$api.teachingManage.teachingScheme
                        .queryAllCourses({
                            data: param,
                        })
                        .then((res) => {
                            this.$refs.CAP.optionCourses = res.data;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    this.$api.teachingManage.teachingScheme
                        .queryAllPositions()
                        .then((res) => {
                            this.$refs.occupation.optionPosition = res.data;
                        })
                        .catch((err) => {
                            console.log(err);
                        });

                    this.$nextTick(() => {
                        this.loadInfo(schemeId);
                        this.$refs.CAP.loadComboOption(mode);
                    });
                }
            },
            loadParams(id) {
                //根据选择的专业查询相关课程
                this.id = id;
                let majorId = this.$refs.teachingForm.createdForm.jpZydm;
                let mode = this.$refs.teachingForm.createdForm.jpMsdm;
                if (majorId == "") return;
                this.$refs.CAP.loadComboOption(mode);
                let param = {
                    majorId: majorId,
                    schemeId: id,
                };
                this.$api.teachingManage.teachingScheme
                    .queryCourses({
                        data: param,
                    })
                    .then((res) => {
                        this.publicCourse = res.data.data.publicCourses;
                        this.majorCoreCourse = res.data.data.majorCoreCourses;
                        this.majorSkillCourse = res.data.data.majorSkillCourses;
                        this.electiveCourse = res.data.data.electiveCourses;
                        this.comprehensiveCourse =
                            res.data.data.comprehensiveCourses;
                        this.other = res.data.data.others;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            loadInfo(schemeId) {
                //根据培养方案查询
                this.$refs.comment.param.schemeId = schemeId;
                let param = {
                    schemeId: schemeId,
                };
                this.$api.teachingManage.teachingScheme
                    .loadInfo({
                        data: param,
                    })
                    .then((res) => {
                        let data = res.data;
                        this.$refs.teachingForm.createdForm = data.scheme;
                        this.$refs.occupation.domain = data.domain;
                        this.$refs.occupation.position = data.position;
                        this.$refs.occupation.certificate = data.certificate;
                        this.$refs.talent.quality = data.quality;
                        this.$refs.talent.ability = data.ability;
                        this.$refs.comment.coms = data.scheme.jpBz;
                        this.$refs.CAP.CAPS = data.caps;
                        if (data.fileList.length != 0)
                            data.fileList[0].url =
                            Vue.prototype.HOST_PROXY_ADMIN +
                            data.fileList[0].url;
                        this.$refs.comment.fileList = data.fileList;
                        this.loadParams(schemeId);
                        if (data.weeks.length != 0) this.data2Weeks(data.weeks);
                        if (data.arrangement.length != 0)
                            this.arrange2N(data.arrangement);
                        this.unlock();
                        this.etype = data.scheme.jpShzt;
                        if (data.scheme.jpShzt == "1") this.state = true;
                        this.$nextTick(() => {
                            // 改变合计行样式
                            $(".el-table__footer-wrapper").css(
                                "font-weight",
                                "bold"
                            );
                            $(".el-table__footer-wrapper tr").css(
                                "font-weight",
                                "bold"
                            );
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            arrange2N(data) {
                //培养安排数据整理
                data[0].name = "一";
                data[1].name = "二";
                data[2].name = "三";
                data[3].name = "四";
                data[4].name = "五";
                data[5].name = "六";
                this.$refs.arrangement.arrangeMent = data;
            },
            data2Weeks(data) {
                //培养周数数据整理
                let ans = [];
                let week = {
                    t1: data[0],
                    t2: data[1],
                    t3: data[2],
                    t4: data[3],
                    t5: data[4],
                    t6: data[5],
                };
                ans.push(week);
                this.$refs.teachingWeeks.teachingWeeks = ans;
                this.$refs.teachingWeeks.handleChange();
            },
            combineprogress(data, row, index, kinds) {
                // only change
                if (data.length == this.progress.length) {
                    this.progressdatachange(row, index, kinds);
                    return;
                }

                let origin = {
                    jjKcdm: null,
                    jjKcmc: "",
                    jjKclx: null,
                    jjXf: 0,
                    jjZxs: 0,
                    jjLljx: 0,
                    jjSysx: 0,
                    jjXq1: 0,
                    jjXq2: 0,
                    jjXq3: 0,
                    jjXq4: 0,
                    jjXq5: 0,
                    jjXq6: 0,
                    kindName: "",
                };

                // add a new course
                if (data.length > this.progress.length) {
                    let ele = data[data.length - 1];
                    let copy = { ...origin
                    };
                    let index = ele.jkKclx;
                    copy.jjKcdm = ele.fullName.split("-")[0];
                    copy.jjKcmc = ele.fullName.split("-")[1];
                    copy.jjZxs = undefined == ele.jjZxs ? ele.jkKss : ele.jjZxs;
                    copy.jjXf = undefined == ele.jjXf ? ele.jkXf : ele.jjXf;
                    copy.jjKclx = index;
                    copy.kindName =
                        index === "0" ? "顶岗实习" : kinds[index - 1].label;
                    copy.jjLljx = ele.jjLljx;
                    copy.jjSysx = ele.jjSysx;
                    copy.jjXq1 = ele.jjXq1;
                    copy.jjXq2 = ele.jjXq2;
                    copy.jjXq3 = ele.jjXq3;
                    copy.jjXq4 = ele.jjXq4;
                    copy.jjXq5 = ele.jjXq5;
                    copy.jjXq6 = ele.jjXq6;
                    this.progress.push(copy);
                }

                // minus checked courses
                if (data.length < this.progress.length) {
                    let container = [];
                    for (let ele of data) {
                        let copy = { ...origin
                        };
                        let index = ele.jkKclx;
                        copy.jjKcdm = ele.fullName.split("-")[0];
                        copy.jjKcmc = ele.fullName.split("-")[1];
                        copy.jjZxs = undefined == ele.jjZxs ? ele.jkKss : ele.jjZxs;
                        copy.jjXf = undefined == ele.jjXf ? ele.jkXf : ele.jjXf;
                        copy.jjKclx = index;
                        copy.kindName =
                            index === "0" ? "顶岗实习" : kinds[index - 1].label;
                        copy.jjLljx = ele.jjLljx;
                        copy.jjSysx = ele.jjSysx;
                        copy.jjXq1 = ele.jjXq1;
                        copy.jjXq2 = ele.jjXq2;
                        copy.jjXq3 = ele.jjXq3;
                        copy.jjXq4 = ele.jjXq4;
                        copy.jjXq5 = ele.jjXq5;
                        copy.jjXq6 = ele.jjXq6;
                        container.push(copy);
                    }

                    this.progress = container;
                }
                this.$refs.progress.renderFlag = false;
                this.$nextTick().then(() => {
                    this.$refs.progress.renderFlag = true;
                });
            },
            transweeks(weeks) {
                //使得progress里表头数据动态绑定
                this.$refs.progress.weeks = weeks;
            },
            changeArrange(value) {
                //使得arrangement里的课堂教学动态绑定
                this.$refs.arrangement.arrangeMent[0].jjKtjx = value.t1.jxJxzs;
                this.$refs.arrangement.arrangeMent[1].jjKtjx = value.t2.jxJxzs;
                this.$refs.arrangement.arrangeMent[2].jjKtjx = value.t3.jxJxzs;
                this.$refs.arrangement.arrangeMent[3].jjKtjx = value.t4.jxJxzs;
                this.$refs.arrangement.arrangeMent[4].jjKtjx = value.t5.jxJxzs;
                this.$refs.arrangement.arrangeMent[5].jjKtjx = value.t6.jxJxzs;
            },
            submitWapper() {
                //提交时触发
                confirmMsg('提交后将无法再次修改当前人才培养方案，是否继续？').then(() => {
                    this.saveScheme("submit");
                });
            },
            saveScheme(type) {
                this.lock();
                let x = this.$refs.teachingForm.createdForm;
                let errorMsg = "";
                if (x.jpXn == "") {
                    errorMsg = "请选择起效学年";
                } else if (x.jpMsdm == "") {
                    errorMsg = "请选择模式";
                } else if (x.jpZydm == "") {
                    errorMsg = "请选择专业名称";
                }

                if (errorMsg.length > 0) {
                    this.$notify({
                        title: "错误",
                        message: errorMsg,
                        type: "error",
                        duration: 3000,
                    });
                    errorMsg = "";
                    this.unlock();
                    return;
                }

                //设置审核状态
                if (type == "save") {
                    x.jpShzt = "0";
                }
                if (type == "submit") {
                    x.jpShzt = "1";
                }
                if (type == "audit") {}

                let occupation = this.$refs.occupation.domain.concat(
                    this.$refs.occupation.position,
                    this.$refs.occupation.certificate
                );
                if (this.$refs.comment.fileList.length != 0) {
                    this.$refs.teachingForm.createdForm.jpYjlj = this.$refs.comment.fileList[0].originPath;
                    this.$refs.teachingForm.createdForm.jpYjwjm = this.$refs.comment.fileList[0].name;
                }

                let params = {
                    scheme: this.$refs.teachingForm.createdForm,
                    weeks: this.$refs.teachingWeeks.teachingWeeks,
                    quality: this.$refs.talent.quality,
                    ability: this.$refs.talent.ability,
                    arrangement: this.$refs.arrangement.arrangeMent,
                    occupation: occupation,
                    caps: this.$refs.CAP.CAPS,
                    coms: this.$refs.comment.coms,
                };
                this.$api.teachingManage.teachingScheme
                    .saveScheme({
                        data: params,
                    })
                    .then((res) => {
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.unlock();
                        this.afterSave(type);
                    })
                    .catch((err) => {
                        this.$notify({
                            title: "错误",
                            message: err,
                            type: "error",
                            duration: 3000,
                        });
                        this.unlock();
                    });
            },
            afterSave(type) {
                this.isEdit = true;
                this.schemeDialogTitle = "编辑";
                if (type == "save") {
                    this.etype = "0";
                    this.$refs.teachingForm.createdForm.jpShzt = "0";
                    this.schemeId = this.$refs.teachingForm.createdForm.jpBh;
                }
                if (type == "submit") {
                    this.etype = "1";
                    this.$refs.teachingForm.createdForm.jpShzt = "1";
                    this.state = true;
                }
            },
            openWindow(query) {
                if (this.$refs.teachingForm.createdForm.jpBh == "") {
                    this.$notify({
                        title: "错误",
                        message: "请先选择基本信息",
                        type: "error",
                        duration: 3000,
                    });
                    return;
                }

                query = this.$refs.teachingForm.createdForm.jpBh + query;
                query = apiUrl.zhxt.frontendUrl + "#/criterion_for_curriculum/" + query;
                window.open(query);
            },
            progressdatachange(row, index, kinds) {
                //教学进程数据改动
                let i = row.jkKclx;
                this.progress[index].kindName = kinds[i - 1].label;
                this.progress[index].jjKclx = i;
                this.progress[index].jjZxs = row.jkKss;
                this.progress[index].jjXf = row.jkXf;
                this.progress[index].jjKcdm = row.jkKcdm;
                this.progress[index].jjKcmc = row.jkKcmc;
            },
            progresstocourse(row, index) {
                //进程数据到课程流动
                this.$refs.course.courses[index].jjLljx = row.jjLljx;
                this.$refs.course.courses[index].jjSysx = row.jjSysx;
                this.$refs.course.courses[index].jjXq1 = row.jjXq1;
                this.$refs.course.courses[index].jjXq2 = row.jjXq2;
                this.$refs.course.courses[index].jjXq3 = row.jjXq3;
                this.$refs.course.courses[index].jjXq4 = row.jjXq4;
                this.$refs.course.courses[index].jjXq5 = row.jjXq5;
                this.$refs.course.courses[index].jjXq6 = row.jjXq6;
                this.$refs.course.courses[index].jjZxs = row.jjZxs;
                this.$refs.course.courses[index].jjXf = row.jjXf;
            },
            setTimer(timer) {
                if (timer != 0 || !this.isEdit) return;
                this.timer++;
                setInterval(this.intervalFun(), 60 * 1000);
            },
            intervalFun() {
                let x = this.$refs.teachingForm.createdForm;
                if (x.jpBh == "") return;
                let occupation = this.$refs.occupation.domain.concat(
                    this.$refs.occupation.position,
                    this.$refs.occupation.certificate
                );
                if (this.$refs.comment.fileList.length != 0) {
                    this.$refs.teachingForm.createdForm.jpYjlj = this.$refs.comment.fileList[0].originPath;
                    this.$refs.teachingForm.createdForm.jpYjwjm = this.$refs.comment.fileList[0].name;
                }
                let params = {
                    scheme: this.$refs.teachingForm.createdForm,
                    weeks: this.$refs.teachingWeeks.teachingWeeks,
                    quality: this.$refs.talent.quality,
                    ability: this.$refs.talent.ability,
                    courses: this.$refs.course.courses,
                    arrangement: this.$refs.arrangement.arrangeMent,
                    occupation: occupation,
                    progress: this.$refs.progress.progress,
                    coms: this.$refs.comment.coms,
                };
                this.$api.teachingManage.teachingScheme
                    .saveScheme({
                        data: params,
                    })
                    .then((res) => {})
                    .catch((err) => {});
            },
            changeEditRow(refName) {
                //职业领域
                if (refName != "domain")
                    this.$refs.occupation.$refs.domain.setCurrentRow();
                //职业岗位
                if (refName != "position")
                    this.$refs.occupation.$refs.position.setCurrentRow();
                //职业证书
                if (refName != "certificate")
                    this.$refs.occupation.$refs.certificate.setCurrentRow();
                //职业素养
                if (refName != "qualityTable")
                    this.$refs.talent.$refs.qualityTable.setCurrentRow();
                //职业能力
                if (refName != "abilityTable")
                    this.$refs.talent.$refs.abilityTable.setCurrentRow();
                //教学周数
                //if(refName!='teachingWeeksTable') this.$refs.teachingWeeks.$refs.teachingWeeksTable.setCurrentRow();
                //课程内容与要求
                // if(refName!='teachingWeeksTable') this.$refs.teachingWeeks.$refs.teachingWeeksTable.setCurrentRow();
                //教学活动时间安排表
                if (refName != "arrangementTable")
                    this.$refs.arrangement.$refs.arrangementTable.setCurrentRow();
                //教学进程表
                if (refName != "CAPTable")
                    this.$refs.CAP.$refs.CAPTable.setCurrentRow();
            },
            lock() {
                this.state = true;
            },
            unlock() {
                this.state = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .myfooter {
        margin-left: 67%;
        margin-top: 2%;
    }

    .scrollArea /deep/.el-scrollbar {
        .is-vertical {
            width: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// schemeView.vue?7bffa95d